module.exports = __webpack_public_path__ + "img/garden.de83b1a7.jpg";